import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import useIsMobileAndPortrait from "../../../../hooks/useIsMobile";

// Registrar escalas y elementos
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const VotesChart = ({ players, position }) => {
  const { isMobile } = useIsMobileAndPortrait()
  // players es algo como goldenBall.nominatedPlayers.defensaLateral
  console.log('@@players', players)
  const data = {
    labels: players?.map(p => {
    const name = p?.jugador?.name || "";
    return name.length > 15 ? name.slice(0, 15) + "…" : name;
  }), // nombres de jugadores
    datasets: [
      {
        label: `Votos de ${position}`,
        data: players?.map(p => p?.votos), // votos
        backgroundColor: "rgba(212, 175, 55, 0.8)", // color dorado semi-transparente
        borderRadius: 6, // bordes redondeados
        barThickness:  isMobile ? 8 : 18, // barras finas
      },
    ],
  };

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: position,
        color: "#f5f5f5",
        font: {
          size: 20,
          weight: "bold",
        },
        padding: {
        },
      },
      tooltip: {
        backgroundColor: "#222", // oscuro
        titleColor: "#f5f5f5",
        bodyColor: "#ddd",
        borderColor: "rgba(212, 175, 55, 0.7)", // borde dorado
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: {
          drawBorder: false,
          color: "rgba(255,255,255,0.2)", // líneas muy sutiles
        },
        ticks: {
          color: "#bbb",
        },
      },
      y: {
        grid: {
                      drawBorder: false,
          color: "rgba(255,255,255,0.05)", // líneas muy sutiles
        },
          beginAtZero: true,
        ticks: {
          color: "#fff",
          font: {
            weight: "500",
          },
        },
      },
    },
  };

  return (
    <div style={{ height: "400px", margin:'50px 0' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default VotesChart;
